import React from 'react'
import classNames from 'classnames'
import './checkbox.scss'

interface IProps {
  className?: string
  isActive: boolean
  onClick: (event: React.MouseEvent<HTMLElement>) => void
  title: string
}

export const Checkbox = ({ className, isActive, onClick, title }: IProps): React.ReactElement => {

  return (
    <li onClick={onClick}>
      <span className={classNames('checkbox', isActive && 'active', className)} />
      {title}
    </li>
  )
}
